
import { Dossier } from "@/models/dossier";
import { CompanyService, UserService } from "@/services";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			loginUrl: "",
		};
	},
	props: {
		targetDossier: {
			type: Object as ()=>Dossier,
			required: true
		}
	},
	watch: {
		"targetDossier.id": {
			immediate: true,
			async handler(){
				this.fetchLoginUrl();
			}
		}
	},
	methods: {
		async fetchLoginUrl(){
			let company = await CompanyService.getCompany(this.targetDossier.companyId);
			let owner = company.owner;
			if (!owner) return;
			let result = await UserService.getLoginAsUserUrl(owner);
			this.loginUrl = result.url;
		},
		copyLoginUrl(){
			let input = document.createElement("input");
			input.value = this.loginUrl;
			document.body.appendChild(input);
			input.select();
			document.execCommand("copy");
			this.$wf.notify("Link is gekopiëerd", "success", 3000, "check");
			input.remove();
		},
		async openAccount(){
			this.$router.push("/companies/" + this.targetDossier.companyId + "/edit");
		},
		loginAsUser(){
			window.open(this.loginUrl, "_blank");
		}
	}
});
